export default {
  brand: "USFansLink",
  nav_spreadsheet: "Arkusz",
  nav_guides: "Poradniki",
  nav_reviews: "Opinie",
  nav_shipping: "Wysyłka",
  nav_coupon: "Kupony",
  nav_warehouse: "Magazyn",
  nav_safety: "Bezpieczeństwo",
  nav_faq: "FAQ",
  nav_home: "Strona główna",
  nav_shopping_guide: "Przewodnik zakupowy",
  explore_main: "Zobacz główną stronę",
  back_home: "Wróć na stronę główną",
  read_more: "Czytaj więcej",
  visit_main: "Odwiedź główną stronę",
  independent_note: "Niezależne źródło informacji · Niepowiązane oficjalnie z USFans",
  language_label: "Język",
  cat_shoes: "Buty",
  cat_hoodies: "Bluzy / Swetry",
  cat_tshirts: "Koszulki",
  cat_jackets: "Kurtki",
  cat_pants: "Spodnie / Szorty",
  cat_headwear: "Nakrycia głowy",
  cat_sets: "Zestawy",
  cat_underwear: "Bielizna / Bokserki",
  cat_jersey: "Koszulki sportowe",
  cat_accessories: "Akcesoria",
  cat_bags: "Torby",
  cat_belts: "Paski",
  cat_perfumes: "Perfumy",
  cat_other: "Inne rzeczy",
  footer_resources: "Zasoby",
  footer_company: "Firma",
  footer_links: "Szybkie linki",
  footer_about: "O nas",
  footer_contact: "Kontakt",
  footer_editorial: "Polityka redakcyjna",
  footer_updates: "Aktualizacje",
  footer_disclaimer: "Zastrzeżenie",
  footer_privacy: "Polityka prywatności",
  footer_terms: "Regulamin",
  footer_rights: "Wszelkie prawa zastrzeżone.",
  footer_tagline: "Niezależne centrum zasobów, poradników i informacji o bezpieczeństwie USFans spreadsheet.",
};